<template>
  <div class="stockManage">
    <!-- 列表 -->
    <div class="list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="min-height:100%">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getList"
          :offset="10"
        >
          <div
            class="list-item"
            v-for="(item,index) in list"
            :key="index"
            :disabled="item.status==2"
            @click="item.status!=2?toUpdate(item.id):''"
          >
            <div class="list-content">
              <div>
                <div class="header_name">
                  <span>货&emsp;&emsp;主：</span>
                  <span class="van-ellipsis">{{item.supplier.name}}</span>

                  <div class="item_type item_type_zy" v-if="item.type == 1">自营</div>
                  <div class="item_type item_type_dm" v-else>代卖</div>
                </div>
                <div>货品名：{{ item.name }}</div>
                <!-- 散装 -->
                <template v-if="item.bale==3">
                  <div>进货量：{{ item.weight *1}}公斤</div>
                  <div>
                    库存量：
                    <span :class="Number(item.last_total)<0?'red':''">{{ item.last_total*1 }}</span>公斤
                  </div>
                  <div>销售量：{{ item.xs_total*1 }}公斤</div>
                  <div >报损：{{ item.damaged_total? item.damaged_total:0}}公斤</div>
                </template>
                <!-- 非定装 -->
                <template v-if="item.bale==2">
                  <div>进货量：{{ item.num*1}}{{unit_list[item.num_unit-1].name}}({{Number(item.weight).toFixed(2)}}公斤)</div>
                  <div>
                    库存量：
                    <span >
                      <span :class="Number(item.lase_num)<0?'red':''">{{item.lase_num*1 }}{{unit_list[item.num_unit-1].name}}</span>
                      <span :class="Number(item.last_total)<0?'red':''">({{ item.last_total*1 }}公斤)</span>
                    </span>
                  </div>
                  <div>销售量：{{ item.xs_num*1 }}{{unit_list[item.num_unit-1].name}}({{item.xs_total*1}}公斤)</div>
                  <div >报损：{{ item.damaged_num ?parseInt(item.damaged_num):0}}{{unit_list[item.num_unit-1].name}}<span v-if="item.damaged_total>0">({{item.damaged_total}}公斤)</span></div>
                </template>
                <!-- 定妆 -->
                <template v-if="item.bale==1">
                  <div>进货量：{{ item.num*1}}{{unit_list[item.num_unit-1].name}}({{Number(item.weight).toFixed(2)}}公斤)</div>
                  <div>
                    库存量：
                    <span
                      :class="Number(item.last_total_num)<0?'red':''"
                    >{{ item.last_total_num*1 }} {{unit_list[item.num_unit-1].name}}</span>
                    <span>({{ item.last_total*1 }}公斤)</span>
                   
                  </div>
                  <div>销售量：{{ item.xs_total_num*1 }}{{unit_list[item.num_unit-1].name}}</div>
                  <div
                    
                  >报损：{{ item.damaged_total_num? parseInt(item.damaged_total_num):0}}{{unit_list[item.num_unit-1].name}}<span v-if="item.damaged_total>0">({{item.damaged_total}}公斤)</span>
                  
                  </div>
                </template>
                <!-- 非定装 -->
                <!-- <template v-if="item.bale==2">
                  <div>进货量：{{ item.num*1}}{{unit_list[item.num_unit-1].name}}
                    <span style="font-size:0.24rem;color:#999">（{{item.weight_kg*1}}公斤）</span>
                  </div>
                  <div>
                    库存量：
                    <span
                      :class="Number(item.last_total_num)<0?'red':''"
                    >{{ item.last_total_num*1 }}</span>
                    {{unit_list[item.num_unit-1].name}} 
                    <span style="font-size:0.24rem;color:#999">（{{item.last_total*1}}公斤）</span>
                  </div>
                  <div>销售量：{{ item.xs_total_num*1 }}{{unit_list[item.num_unit-1].name}}
                    <span style="font-size:0.24rem;color:#999">（{{item.xs_total*1}}公斤）</span>
                  </div>
                  <div
                    v-if="item.damaged_num*1"
                  >报损：{{ item.damaged_num*1 }}公斤</div>
                </template>-->
              </div>
              <div v-if="item.status!=1" class="shouqing">
                <img src="../../../../assets/img/work/manage/stock_saleoff.png" alt />
              </div>
            </div>
            <div class="list-date">
              <span>创建时间：{{item.create_time | toTime}}</span>
              <span>
                <!-- <van-icon  v-if="item.status ==1" name="ellipsis" size="0.4rem" @click.stop="shouActionFun(item)"/> -->
              </span>
            </div>
            <div class="btns" style="text-align:right;margin-top:0rem" v-if="item.status ==1">
              <van-button
                round
                type="primary"
                size="small"
                style="font-size:0.30rem;margin-bottom:0.3rem"
                @click.stop="toBrake(item)"
              >报损</van-button>
              <van-button
                round
                type="warning"
                size="small"
                style="font-size:0.30rem"
                @click.stop="handleDelete(item)"
              >售罄</van-button>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- 弹出层 -->
    <van-action-sheet
      v-model="showAction"
      :actions="actionsSelect"
      cancel-text="取消"
      :close-on-popstate="true"
      @cancel="showAction = false"
      @select="selectAction"
    />
    <!-- <van-popup v-model="show" position="bottom" >
      <div class="sale-btn" @click="handleDelete(item)">售罄</div>
      <div class="sale-btn sale-btn-2" @click="$router.push('/manage/stock/brakeDetail'),show=false">报损</div>
      <div class="sale-btn sale-btn-3">编辑</div>
      <div class="sale-btn" @click="show=false">取消</div>
    </van-popup>-->
    <div class="bottom" @click="$router.push('/manage/stock/addStock')">进货</div>
  </div>
</template>

<script>
import { stock_list, stock_delete } from "@/api/work/manage/stock";
import { timestampToTime } from "@/utils/timestamp";
export default {
  name: "stockManage",
  data() {
    return {
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      showAction: false, //弹出层
      list: [],
      loading: true,
      finished: true,
      refreshing: false,
      listQuery: {
        page: 1,
        pageSize: 15,
        name: "",
        status: ""
      },

      actionsSelect: [
        { name: "售罄", value: "1" },
        { name: "报损", value: "2" },
        { name: "编辑", value: "3" }
      ]
    };
  },
  filters: {
    toTime(t) {
      return timestampToTime(t);
    }
  },
  created() {
    this.getList();
    this.$navigation.on("back", (to, from) => {
      if (to.route.name == "manage_stock_stockManage") {
        if (
          from.route.name == "manage_stock_editStock" ||
          from.route.name == "manage_stock_brakeDetail" ||
          from.route.name == "manage_stock_addStock"
        ) {
          var listQuery = {
            page: 1,
            pageSize: this.finished ? this.list.length + 1 : this.list.length,
            name: this.listQuery.name,
            status: this.listQuery.status
          };
          stock_list(listQuery).then(res => {
            if (res.code == 200) {
              this.list = res.data.list;
              if (
                this.list.length == res.data.totalCount ||
                res.data.list.length == 0
              ) {
                this.finished = true;
              } else {
                this.finished = false;
                this.loading = false;
                this.listQuery.pageSize = "15";
              }
            }
          });
        }
      }
    });
  },
  mounted() {},
  methods: {
    // 获取列表
    getList() {
      stock_list(this.listQuery).then(res => {
        if (res.code == 200) {
          if (this.listQuery.page == 1) this.list = [];
          this.list = this.list.concat(res.data.list);
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.finished = true;
          } else {
            this.finished = false;
            this.loading = false;
            this.listQuery.page++;
          }
          this.refreshing = false;
        }
      });
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.refreshing = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.listQuery.page = 1;
      this.getList();
    },

    // 售罄
    handleDelete(item) {
      this.$dialog
        .confirm({
          title: "是否售罄本批次？",
          message: "售罄后，本批次将不在下单页面出现！"
        })
        .then(() => {
          // on confirm
          stock_delete({ id: item.id }).then(res => {
            // this.onRefresh()
            this.listQuery.page = 1;
            this.getList();
            this.showAction = false;
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    // 去报损
    toBrake(item) {
      this.$router.push({
        path: "/manage/stock/brakeDetail",
        query: {
          batch: item.batch
        }
      });
    },

    // 去编辑
    toUpdate(id) {
      this.$router.push({
        path: "/manage/stock/editStock",
        query: {
          id
        }
      });
    },

    // 显示操作
    shouActionFun(item) {
      this.activeItem = item;
      this.showAction = true;
    },
    // 点击了选项
    selectAction(action) {
      if (action.value == 1) {
        this.handleDelete(this.activeItem);
      } else if (action.value == 2) {
        this.toBrake(this.activeItem);
      } else {
        const {
          id,
          batch,
          type,
          supplier_id,
          name,
          bale,
          unit,
          num_unit,
          num,
          bale_num,
          weight,
          price
        } = this.activeItem;
        let queryData = {
          id,
          batch,
          type,
          supplier_id,
          name,
          bale,
          unit,
          num_unit,
          num,
          bale_num,
          weight,
          price
        };
        queryData.supplier_name = this.activeItem.supplier.name;
        this.toUpdate(queryData);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "manage") {
      this.$navigation.off("back");
    }
    next(); //一定不要忘记写
  }
};
</script>

<style lang="less" scoped>
.stockManage {
  padding-bottom: 1rem;
  .list-content {
    & > div {
      & > div {
        width: 5rem;
        span {
          white-space: nowrap;
        }
      }
    }
  }
  .header_name {
    display: flex;
    align-items: center;
    span:nth-child(2) {
      flex-shrink: 1;
    }
  }
  .list-item {
    width: 6.5rem;
    margin: 0.2rem auto 0;
    background-color: #fff;
    padding: 0.2rem;
    position: relative;
    &[disabled] {
      * {
        color: #999 !important;
      }
    }
    .red {
      color: #f00;
    }
    .btns {
      position: absolute;
      top: 0.4rem;
      right: 0.2rem;
      width: 1.2rem;
    }
    .list-content {
      font-size: 0.32rem;
      color: #333333;
      line-height: 0.51rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 0.1rem;
      .shouqing {
        img {
          width: 1rem;
          height: 1rem;
        }
      }

      .item_type {
        font-size: 0.24rem;
        text-align: center;
        line-height: 0.32rem;
        white-space: nowrap;
        margin-left: 0.3rem;
        display: block;

        text-align: center;
        border-radius: 0.06rem;
        padding: 0.05rem 0.1rem;
      }
      .item_type_zy {
        background: rgba(28, 192, 233, 0.3);
        color: #268ea7;
      }
      .item_type_dm {
        background: rgba(233, 153, 28, 0.3);
        color: #c6601c;
      }
    }
    .list-date {
      padding-top: 0.1rem;
      border-top: 0.01rem solid #f5f5f5;
      color: #999999;
      display: flex;
      justify-content: space-between;
      .van-icon {
        vertical-align: middle;
      }
    }
  }
  .sale-btn {
    width: 100%;
    background-color: #fff;
    line-height: 1.14rem;
    text-align: center;
    font-size: 0.36rem;
  }
  .sale-btn-2 {
    border-top: 0.01rem solid #e5e5e5;
  }
  .sale-btn-3 {
    border-top: 0.01rem solid #e5e5e5;
    border-bottom: 0.1rem solid #207339;
  }
  .bottom {
    background-color: #31b158;
    color: #fff;
    font-size: 0.36rem;
    line-height: 1rem;
    text-align: center;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
}
</style>